import { Search as SearchIcon } from '@mui/icons-material';
import Button from '@mui/material/Button/Button';
import Card from '@mui/material/Card/Card';
import FormControl from '@mui/material/FormControl/FormControl';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';
import InputLabel from '@mui/material/InputLabel/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput/OutlinedInput';
import React, {
  CSSProperties,
  FC,
  MutableRefObject,
  useRef,
  useState
} from 'react';
import { Box, MenuItem, Select } from '@mui/material';

type Props<T> = {
  searchByFields: { field: T; label: string }[];
  onSubmit: (query: string, searchBy: T) => void;
  onSearchByChange: (newSearchBy: T) => void;
  styles?: CSSProperties;
};

export const Search = <T extends string>({
  searchByFields,
  onSubmit,
  onSearchByChange,
  styles
}: Props<T>) => {
  const [searchBy, setSearchBy] = useState<T>(searchByFields[0]?.field);
  const inputRef: MutableRefObject<HTMLInputElement> = useRef();

  const handleSearchByChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchBy = event.target.value as T;
    setSearchBy(newSearchBy);
    onSearchByChange(newSearchBy);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
      }}
    >
      <Card style={{ padding: 8, flexGrow: 1, overflow: 'visible', ...styles }}>
        <FormControl sx={{ display: 'flex', flexGrow: 1 }}>
          <InputLabel htmlFor="modal-search">Search</InputLabel>
          <OutlinedInput
            inputProps={{ maxLength: 48 }}
            ref={inputRef}
            id="modal-search"
            label="Enter for search"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                const input = inputRef.current.querySelector('input');
                onSubmit(input.value, searchBy);
              }
            }}
            endAdornment={
              <Button
                sx={{ padding: 2.2 }}
                onClick={() => {
                  const input = inputRef.current.querySelector('input');
                  onSubmit(input.value, searchBy);
                }}
              >
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Button>
            }
          />
        </FormControl>
      </Card>
      {searchByFields.length > 1 ? (
        <Card sx={{ overflow: 'visible' }}>
          <Select
            sx={{ margin: '10px' }}
            variant="outlined"
            autoWidth
            value={searchBy}
            onChange={handleSearchByChange}
          >
            {searchByFields.map((field, index) => (
              <MenuItem key={index} value={field.field}>
                {field.label}
              </MenuItem>
            ))}
          </Select>
        </Card>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default Search;
